import { PropsWithChildren, ReactElement } from 'react';
import { Flex, Box } from '@wegroup/design-system';
import Toolbar from '../toolbar/Toolbar';

interface Props {
  toolbarContent?: ReactElement;
  mobileToolbarContent?: ReactElement;
}

const AdvisoryAppShell = ({
  toolbarContent,
  mobileToolbarContent,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Flex
      flexDir={{ base: 'column', laptop: 'row' }}
      h="100%"
      w="100%"
      bg="#fdfcff"
      position="relative"
    >
      <Toolbar
        toolbarContent={toolbarContent}
        mobileToolbarContent={mobileToolbarContent}
      />
      <Box flexGrow={1} w="100%" position="relative">
        {children}
      </Box>
    </Flex>
  );
};

export default AdvisoryAppShell;
